export default __webpack_public_path__ + "static/media/support-team.e90e3d7e.png";